import { connect } from 'react-redux'
import { Alerts } from './Alerts.jsx'
import { getAlerts } from 'redux/notifications/selectors'

const mapStateToProps = (state, ownProps) => ({
    alerts: getAlerts(state),
})

export const AlertsContainer = connect(
    mapStateToProps,
)(Alerts)
